/**
 * 模拟考试文案
 */
export default {
  difficulty: 'クラス',
  mockDuration: '模擬期間',
  intro: '簡単な紹介',
}
